export const scopes = {
  BILLING_ACCESS: 'billing-access',
  BREEZE_INTELLIGENCE_FREE: 'breeze-intelligence-free',
  DATA_ENRICHMENT_ACCESS: 'data-enrichment-access',
  ENRICHMENT_PLATFORM_ACCESS: 'data-enrichment-platform-access',
  ENRICHMENT_UNLIMITED_USAGE: 'data-enrichment-unlimited-usage',
  SUPER_ADMIN: 'super-admin'
};